"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroupSvg = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
class AvatarGroupSvg extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { viewBox, children, ...otherProps } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ viewBox: `0 0 ${viewBox} ${viewBox}`, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" }, otherProps, { children: children }), void 0));
        };
    }
}
exports.AvatarGroupSvg = AvatarGroupSvg;
AvatarGroupSvg.propTypes = {
    children: prop_types_1.default.node.isRequired,
    viewBox: prop_types_1.default.number.isRequired
};
exports.default = AvatarGroupSvg;
//# sourceMappingURL=avatar.group.svg.js.map